import { createBrowserRouter, Outlet } from "react-router-dom";
import Home from "@pages/Home";
import CallbackRequests from "@pages/CallbackRequests/CallbackRequests";
import RoutePaths from "./routePaths";
import Layout from "./components/Layout/Layout";
import AccessControler from "@components/AccessControler/AccessControler";
import ManageUsers from '@pages/UserManagement/ManageUsers';
import UserFormPage from '@pages/UserManagement/UserFormPage';

const router = createBrowserRouter([
  {
    element: (
      <Layout>
        <AccessControler>
          <Outlet />
        </AccessControler>
      </Layout>
    ),
    children: [
      {
        path: RoutePaths.Home,
        element: <Home />,
      },
      {
        path: RoutePaths.CallbackRequests,
        element: <CallbackRequests />,
      },
      {
        path: RoutePaths.ManageUsers,
        element: <ManageUsers />,
      },
      {
        path: RoutePaths.AddUser,
        element: <UserFormPage mode="add" />,
      },
      {
        path: RoutePaths.EditUser,
        element: <UserFormPage mode="edit" />,
      },
    ],
  },
]);

export default router;
